/**
 * Created by ganlu on 30/10/2016.
 */
import angular from 'angular';
import progressbarComponent from './progressbar.component';


let progressbarModule = angular.module('progressbar', [])

    .component('progressbar', progressbarComponent)

    .name;

export default progressbarModule;



// WEBPACK FOOTER //
// ./src/app/common/progressbar/progressbar.js